// extracted by mini-css-extract-plugin
export default {"recipeDetails":"RecipeDetails_recipeDetails__scgR4","recipeDetailsHoryzontal":"RecipeDetails_recipeDetailsHoryzontal__NMGAH"};